class Rest {
	private static instance: Rest;
	private constructor() {}

	static getInstance() {
		if (!Rest.instance) Rest.instance = new Rest();
		return Rest.instance;
	}

	get baseUrl() { return 'apx/'; }
	get apiBaseUrl() { return process.env.NEXT_PUBLIC_API_BASE_URL; }
	get authDomain() { return process.env.AUTH_DOMAIN; }
	get loginUrl() { return this.baseUrl + 'auth/login/'; }
	get loginUrlWithAPIBaseUrl() { return this.apiBaseUrl + '/auth/login/'; }
	get logoutUrl() { return this.baseUrl + 'auth/logout/'; } // Logout URL
	get logoutUrlWithAPIBaseUrl() { return this.apiBaseUrl + '/auth/logout/'; }
	get requestTimeOut() { return Number(process.env.REQUEST_TIME_OUT) || 30; }
	get encriptionSalt() { return process.env.ENCRIPTION_SALT || 'aZ*ui$6742!inc_assure'; }
	get versionUrl() { return this.baseUrl + 'standard/version'; }
	get sessionUrl() { return this.baseUrl + 'super-admin/' + this.baseUrl + 'authentication/'; }

	//  Base api urls used for controllers
	get superAdminBaseUrl() { return this.baseUrl + 'super-admin/'; }
	get orgAdminBaseUrl() { return this.baseUrl + 'org-admin/'; }
	get domainBaseUrl() { return this.baseUrl + 'domain/'; }
	get constantsBaseUrl() { return this.baseUrl + 'constants/'; }
	get registerBaseUrl() { return this.baseUrl + 'register/'; }
	get fypUrl() { return this.baseUrl + 'auth/fyp/'; }
	get fypUrlWithAPIBaseUrl() { return this.apiBaseUrl + '/auth/fyp/'; }
	get orgManagerUrl() { return this.baseUrl + 'org-manager/'; }
	get standardUserUrl() { return this.baseUrl + 'user/'; }

	redirectUrl(nextUrl: string) {
		return this.baseUrl + 'session/login?appNextUrl=' + encodeURIComponent(nextUrl) + (
			this.authDomain ? '&domainName=' + this.authDomain : ''
		);
	}

	getRedirectToLoginUrl(nextUrl = window.location.href) {
		document.cookie = 'authToken=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
		return this.loginUrl + '?appNextUrl=' + encodeURIComponent(nextUrl) + (this.authDomain ? '&domainName=' + this.authDomain : '');
	}

	get statusUrl() { return this.baseUrl + 'status'; }

	// Superaadmin api's

	get getAllApplications() { return this.superAdminBaseUrl + 'app/'; }
	get addNewApplication() { return this.superAdminBaseUrl + 'app/'; }
	get createNewApplication() { return this.superAdminBaseUrl + 'app/{appName}'; } // To be depricated
	get updateApplication() { return this.superAdminBaseUrl + 'app/{appId}'; }
	get enableDisableApplication() { return this.superAdminBaseUrl + 'app/{appId}/{enabled}'; }
	get appApplicationMetadata() { return this.superAdminBaseUrl + 'app/metadata/{appId}'; }
	get editApplicationMetadata() { return this.superAdminBaseUrl + 'app/metadata/{appMetaDataId}'; }
	get deleteApplicationMetadata() { return this.superAdminBaseUrl + 'app/metadata/{appMetaDataId}'; }
	get allApplicationResources() { return this.superAdminBaseUrl + 'app/resource/{appId}'; }
	get addApplicationResource() { return this.superAdminBaseUrl + 'app/resource/{appId}'; }
	get allApplicationRoles() { return this.superAdminBaseUrl + 'role/app/{appId}'; }
	get allApplicationResourceRoles() { return this.superAdminBaseUrl + 'role/app-resource/all/{appId}'; }
	get updatApplicationeRole() { return this.superAdminBaseUrl + 'role/{appRoleId}'; }
	get addNewApplicationRole() { return this.superAdminBaseUrl + 'role/app/{appId}/{appResourceId}'; }
	get deleteApplicationRole() { return this.superAdminBaseUrl + 'role/app/{appResourceId}'; }
	get addApplicationUri() { return this.superAdminBaseUrl + 'uri/{appId}'; }
	get deleteApplicationUri() { return this.superAdminBaseUrl + 'uri/{appUriId}'; }

	// Super admin org-scoped role management (ORG_APP / ORG_APP_RESOURCE)
	get getOrgSpecificAppRoles() { return this.superAdminBaseUrl + 'role/org/{orgId}/app/{appId}'; }
	get getOrgSpecificAppResourceRoles() { return this.superAdminBaseUrl + 'role/org/{orgId}/app-resource/{appResourceId}'; }
	get addOrgSpecificRole() { return this.superAdminBaseUrl + 'role/org/{orgId}/app/{appId}'; } // appResourceId is a Query Param (optional)
	get updateOrgSpecificRole() { return this.superAdminBaseUrl + 'role/org/{orgId}/{roleId}'; }

	// Super admin organisation to application mapping
	get mapOrganisationsToApplication() { return this.superAdminBaseUrl + 'org-app/app/{appId}'; }
	get mapApplicationsToOrganisation() { return this.superAdminBaseUrl + 'org-app/org/{orgId}'; }
	get removeOrganisationToApplicationMapping() { return this.superAdminBaseUrl + 'org-app/{mapId}'; }
	get getAllOrganisationsMappedToApplication() { return this.superAdminBaseUrl + 'org-app/app/{appId}'; }
	get getAllApplicationsMappedToOrganisation() { return this.superAdminBaseUrl + 'org-app/org/{orgId}'; }

	// Super admin organisation api's
	get getAllOrganisations() { return this.superAdminBaseUrl + 'org/'; }
	get addNewOrganisation() { return this.superAdminBaseUrl + 'org/'; }
	get updateOrganisation() { return this.superAdminBaseUrl + 'org/{orgId}'; }
	get enableDisableOrganisation() { return this.superAdminBaseUrl + 'org/{orgId}/{enabled}'; }
	get updateOrganisationConfiguration() { return this.superAdminBaseUrl + 'org/config/{orgId}'; }
	get addIpAddressesToDomain() { return this.superAdminBaseUrl + 'org/ip/{orgId}'; }

	// Super admin user attribute key api (keys are managed via org configuration)
	get getUserAttributeKeysForOrg() { return this.superAdminBaseUrl + 'user-attribute-key/{orgId}'; }

	// Super Admin audit log's
	get getSuperAdminAuditLogs() { return this.superAdminBaseUrl + 'audit'; }
	get getOrgAdminAuditLogs() { return this.orgAdminBaseUrl + 'audit'; }

	// SuperAdmin user api's
	get getAllUsersForOrg() { return this.superAdminBaseUrl + 'user/{orgId}'; }
	get getUserForOrg() { return this.superAdminBaseUrl + 'user/{orgId}/{userId}'; }
	get addNewSuperadminUser() { return this.superAdminBaseUrl + 'user/{orgId}'; }
	get bulkAddSuperadminUsers() { return this.superAdminBaseUrl + 'user/bulk/{orgId}'; }
	get updateSuperadminUserStatus() { return this.superAdminBaseUrl + 'user/enable/{userId}/{enable}'; }
	get updateSuperadminMFAStatus() { return this.superAdminBaseUrl + 'user/mfa/{userId}/{enable}'; }
	get updateSuperadminEmailVerificationStatus() { return this.superAdminBaseUrl + 'user/email-verification/{userId}/{enable}'; }
	get resetSuperadminUser() { return this.superAdminBaseUrl + 'user/reset/{userId}'; }
	get updateSuperadminUserDetails() { return this.superAdminBaseUrl + 'user/details/{userId}'; }
	get updateSuperadminUserSecurity() { return this.superAdminBaseUrl + 'user/security/{userId}'; }
	get changeAdminUserPassword() { return this.superAdminBaseUrl + 'user/change-password/{userId}'; }

	get getAllRolesForOrg() { return this.superAdminBaseUrl + 'role/all/{orgId}'; }
	get assignSuperadminUserRole() { return this.superAdminBaseUrl + 'role/user/assign'; }
	get removeSuperadminUserRole() { return this.superAdminBaseUrl + 'role/user/remove/'; }
	get assignSuperadminGroupRole() { return this.superAdminBaseUrl + 'role/group/assign'; }
	get removeSuperadminGroupRole() { return this.superAdminBaseUrl + 'role/group/remove/'; }

	get getAllAppResourcesForOrg() { return this.superAdminBaseUrl + 'app/resource/org/{orgId}'; }
	get getAllOrgResourcesForOrg() { return this.superAdminBaseUrl + 'org/resource/{orgId}'; }
	get addOrgResourceValue() { return this.superAdminBaseUrl + 'org/resource/{orgId}'; } // ?appResourceId is a Query Param here

	get getAllGroupsForOrg() { return this.superAdminBaseUrl + 'group/{orgId}'; }
	get getGroupForOrg() { return this.superAdminBaseUrl + 'group/{orgId}/{groupId}'; }
	get addSuperadminUserToGroup() { return this.superAdminBaseUrl + 'group/{groupId}/{userId}'; }
	get removeSuperadminUserFromGroup() { return this.superAdminBaseUrl + 'group/{groupId}/{userId}'; }
	get addNewSuperadminGroup() { return this.superAdminBaseUrl + 'group/{orgId}'; }

	// Auth URL's
	get loginAuthorize() { return this.loginUrlWithAPIBaseUrl + 'authorize'; }
	get loginUsingCredentials() { return this.loginUrlWithAPIBaseUrl + 'try'; }
	get loginOrg() { return this.loginUrlWithAPIBaseUrl + 'org'; }
	get changePassword() { return this.loginUrlWithAPIBaseUrl + 'change-password'; }
	get sendMfaOtp() { return this.loginUrlWithAPIBaseUrl + 'mfa/send'; }
	get verifyMfaOtp() { return this.loginUrlWithAPIBaseUrl + 'mfa/verify/{otp}'; }
	get sendEmailVerificationToken() { return this.loginUrlWithAPIBaseUrl + 'email-verification/send'; }
	get verifyEmailVerificationToken() { return this.loginUrl + 'email-verification/verify/{token}'; }
	get oauth2Microsoft() { return this.apiBaseUrl + '/oauth2/authorization/azure'; }
	get oauth2Google() { return this.apiBaseUrl + '/oauth2/authorization/google'; }

	// FYP URL's
	get initFypFlow() { return this.fypUrlWithAPIBaseUrl + 'init'; }
	get serachUserExist() { return this.fypUrlWithAPIBaseUrl + 'user'; }
	get sendToken() { return this.fypUrlWithAPIBaseUrl + 'verify/send'; }
	get setNewPassword() { return this.fypUrlWithAPIBaseUrl + 'try'; }

	// Redirect URL's
	get openidAuthorizeRedirect() { return this.baseUrl + 'openid/authorize'; }
	get setCookieRedirect() { return this.loginUrlWithAPIBaseUrl + 'set-cookie'; }

	// Domain URL's
	get getOrgData() { return this.orgManagerUrl + 'org'; }
	get getAllAppsMappedToOrg() { return this.orgManagerUrl + 'org-app/org'; }
	get getAllOrgUsers() { return this.orgManagerUrl + 'user'; }
	get getOrgUser() { return this.orgManagerUrl + 'user/{userId}'; }
	get getAllRoles() { return this.orgManagerUrl + 'role/all'; }
	get getOrgAppRoles() { return this.orgManagerUrl + 'role/app/{appId}'; } // Global APP + ORG_APP (org scoped)
	get getOrgAppResourceRoles() { return this.orgManagerUrl + 'role/app-resource/{appResourceId}'; } // Global APP_RESOURCE + ORG_APP_RESOURCE (org scoped)
	get getAllAppResources() { return this.orgManagerUrl + 'app/resource/org'; }
	get getAllOrgResources() { return this.orgManagerUrl + 'org/resource'; }
	get getAllGroups() { return this.orgManagerUrl + 'group'; }
	get getOrgGroup() { return this.orgManagerUrl + 'group/{groupId}'; }
	get addResourceValue() { return this.orgManagerUrl + 'org/resource/{appResourceId}'; }

	// Org admin organisation config (logged-in org, no orgId path param)
	get updateOrgAdminConfiguration() { return this.orgAdminBaseUrl + 'org/config'; }

	// Org admin role management (ORG_APP / ORG_APP_RESOURCE)
	get addOrgRole() { return this.orgAdminBaseUrl + 'role/app/{appId}'; } // appResourceId is a Query Param (optional)
	get updateOrgRole() { return this.orgAdminBaseUrl + 'role/{roleId}'; }
	
	// Org manager user attribute key api (keys are managed via org configuration)
	get getUserAttributeKeys() { return this.orgManagerUrl + 'user-attribute-key'; }

	get addNewUser() { return this.orgManagerUrl + 'user'; }
	get bulkAddUsers() { return this.orgManagerUrl + 'user/bulk'; }
	get updateUserStatus() { return this.orgManagerUrl + 'user/enable/{userId}/{enable}'; }
	get updateEmailVerificationStatus() { return this.orgManagerUrl + 'user/email-verification/{userId}/{enable}'; }
	get updateMFAStatus() { return this.orgManagerUrl + 'user/mfa/{userId}/{enable}'; }
	get updateUserDetails() { return this.orgManagerUrl + 'user/details/{userId}'; }
	get changeUserPassword() { return this.orgManagerUrl + 'user/change-password/{userId}'; }
	get updateUserSecurity() { return this.orgManagerUrl + 'user/security/{userId}'; }
	get resetUser() { return this.orgManagerUrl + 'user/reset/{userId}'; }

	get assignUserRole() { return this.orgManagerUrl + 'role/user/assign'; }
	get removeUserRole() { return this.orgManagerUrl + 'role/user/remove/'; }
	get assignGroupRole() { return this.orgManagerUrl + 'role/group/assign'; }
	get removeGroupRole() { return this.orgManagerUrl + 'role/group/remove/'; }
	get addUserToGroup() { return this.orgManagerUrl + 'group/{groupId}/{userId}'; }
	get removeUserFromGroup() { return this.orgManagerUrl + 'group/{groupId}/{userId}'; }
	get addNewGroup() { return this.orgManagerUrl + 'group'; }

	// standard user api
	get getStandardUserDetails() { return this.standardUserUrl + 'details'; }
	get getStandardUserAttributeKeys() { return this.standardUserUrl + 'attribute-keys'; }
	get changeStandardUserPassword() { return this.standardUserUrl + 'change-password'; }
}

const restService = Rest.getInstance();

function replacePathParams(url: string, params: {[key: string]: string | number | boolean}, keepUnmatched: boolean = true) {
	// Use a regular expression to find all path parameters in the URL
	return url.replace(/{([^}]+)}/g, (match, paramName) => {

		// Replace the parameter with the corresponding value from the params object
		if (params.hasOwnProperty(paramName)) {
			return encodeURIComponent(params[paramName]);
		}

		// If the parameter is not found in the params object, keep it as is
		return keepUnmatched ? match : '';
	});
}

export { replacePathParams, restService };

/**
	Example usage
	const url = '/admin/api/{app}/domain/{domainId}/resource';
	const params = {
		app: 'myApp',
		domainId: 123
	};

	const newUrl = replacePathParams(url, params);
	
	// Output: '/admin/api/myApp/domain/123/resource'
*/
